import React, { useContext, useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import {
  SpinnerContext,
  routes,
  yup,
  yupResolver,
} from '../../../../utils/shared.module'
import {
  ApiServiceContext,
  SpecialCharacters,
  email,
  end_points,
  lowerCase,
  upperCase,
} from '../../../../services/core.index'
import { Controller, useForm } from 'react-hook-form'
import { toast } from 'react-toastify'
import CryptoJS from 'crypto-js'
import { useParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { setAppTitle, setCompanyEmail } from '../../../../store/commonSlice'
const UserAccess = () => {
  const navigate = useNavigate()
  const { token } = useParams()
  // const { showLoader, hideLoader } = useContext(SpinnerContext)
  const useraccessFormSchema = yup.object({
    first_name: yup
      .string()
      .required('First name is required')
      .max(25, 'First name should be maximum 25 characters long')
      .nullable()
      .trim(),
    last_name: yup
      .string()
      .required('Last name is required')
      .max(25, 'Last name should be maximum 25 characters long')
      .nullable()
      .trim(),
    email: yup
      .string()
      .required('Email address is required')
      .matches(email, 'Enter a valid email address')
      .nullable('Email address is required')
      .max(64)
      .trim(),
    password: yup.string().required('Password address is required').trim(),
    confirm_password: yup
      .string()
      .required('Confirm password address is required')
      .oneOf([yup.ref('password')], 'Password does not match')
      .trim(),
    phone_no: yup
      .string()
      .required('Phone number is required')
      .matches(
        /^\+\d{12}$/,
        'Phone number must start with +country code and be followed by 10 digits',
      )
      .trim(),
  })
  const { postData, getData } = useContext(ApiServiceContext)
  const [errorText, setErrorText] = useState()
  const [error, setError] = useState(false)
  const [tokenValid, setTokenValid] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [passwordType, setPasswordType] = useState('password')
  const [confirmpasswordType, setConfirmPasswordType] = useState('password')
  const [modalMessage, setModalMessage] = useState('')
  const dispatch = useDispatch()
  const {
    handleSubmit,
    control,
    setValue,
    formState: { errors },
    clearErrors,
  } = useForm({
    resolver: yupResolver(useraccessFormSchema),
  })

  useEffect(() => {
    if (tokenValid === true) {
      const encryptedHex: any = token
      const CRYPTO_KEY = 'M5nZ3jkHvcst5HPvEMhQSqrzyhD94Iq6njIi/dxshr0='
      // const secretKey: any = process.env.REACT_APP_CRYPTO_KEY;
      const ivHex = encryptedHex.substring(0, 32)
      const ciphertextHex = encryptedHex.substring(32)
      const iv = CryptoJS.enc.Hex.parse(ivHex)
      const ciphertext: any = CryptoJS.enc.Hex.parse(ciphertextHex)
      const decrypted = CryptoJS.AES.decrypt(
        { ciphertext },
        CryptoJS.enc.Base64.parse(CRYPTO_KEY),
        { iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 },
      )

      const decryptedString = decrypted.toString(CryptoJS.enc.Utf8)
      const handleCompanyUser = JSON.parse(decryptedString).is_company_admin
      if (handleCompanyUser == 'yes') {
        navigate(`/admin-invitation/${token}`)
      }
      const decryptedEmail = JSON.parse(decryptedString).email
      const decryptedCompany = JSON.parse(decryptedString).company_name
      const payload = {
        decryptedEmail,
        decryptedCompany,
      }
      dispatch(setCompanyEmail(payload))
      setValue('email', decryptedEmail)
    }
  }, [tokenValid])

  const getUserInvite = async () => {
    let urls = end_points.userInvitation.url
    const invitation_key = token
    urls += `/${invitation_key}`
    const response = await getData(urls)
    if (response?.status == 200) {
      setTokenValid(true)
    } else {
      setTokenValid(false)
      const errorMessage = response?.data?.message
      setModalMessage(errorMessage)
      setShowModal(true)
    }
  }

  useEffect(() => {
    getUserInvite()
    dispatch(setAppTitle('User Invitation'))
  }, [])

  const onOk = () => {
    navigate(routes.login.path)
  }
  const onSubmit = async (data: any) => {
    const payload = {
      first_name: data?.first_name,
      last_name: data?.last_name,
      phone_no: data?.phone_no,
      password: data?.password,
      confirm_password: data?.confirm_password,
    }
    setError(false)

    try {
      let urls = end_points.userInvitationRegister.url
      const invitation_key = token
      urls += `/${invitation_key}`
      const response = await postData(urls, payload)
      if (response.status == 200) {
        setError(false)
        const errorMessage = response?.data?.message
        setModalMessage(errorMessage)
        setShowModal(true)
        // toast.info('Kindly add')
      } else {
        setError(true)
        setErrorText(response.data.errors[0].msg)
      }
    } catch (e) {
      setError(true)
    }
  }
  return (
    <>
      <div className='requestpage'>
        {/* <div className='requestpage-left'></div> */}
        <div className='requestpage-right'>
          <div className='wizard-request'>
            <ul>
              <li className='active'>
                <div className='requestpage-head'>
                  <div className='reques-page-wizard'>
                    <div className='request-headimg'>
                      <span>
                        <i className='ti ti-user' />
                      </span>
                    </div>
                    <div className='request-headcontent'>
                      <h6>User</h6>
                      <span>User Information</span>
                    </div>
                  </div>
                  <div className='request-headimg'>
                    <Link to='#'>
                      <i className='ti ti-chevron-right' />
                    </Link>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className='requestpage-content'>
              <h5>User Information</h5>
              <h6>Enter Your Details</h6>
              <div className='row'>
                <div className='col-lg-6 col-12'>
                  <div className='form-wrap'>
                    <label className='col-form-label'>First Name </label>
                    <Controller
                      name='first_name'
                      control={control}
                      render={({ field: { value, onChange } }) => (
                        <input
                          className={`form-control  ${
                            errors?.first_name ? 'error-input' : ''
                          }`}
                          type='text'
                          value={value}
                          onChange={onChange}
                          autoComplete='false'
                          placeholder='Enter First name'
                          maxLength={25}
                          onKeyDown={(event) => {
                            const regex = new RegExp('^[a-zA-Z0-9\\s]+$')
                            if (
                              !regex.test(event.key) &&
                              event.key !== 'Backspace'
                            ) {
                              event.preventDefault()
                            }
                          }}
                        />
                      )}
                      defaultValue=''
                    />
                    <small className='error-input'>
                      {errors?.first_name?.message}
                    </small>{' '}
                  </div>
                </div>
                <div className='col-lg-6 col-12'>
                  <div className='form-wrap'>
                    <label className='col-form-label'>Last Name</label>
                    <Controller
                      name='last_name'
                      control={control}
                      render={({ field: { value, onChange } }) => (
                        <input
                          className={`form-control  ${
                            errors?.last_name ? 'error-input' : ''
                          }`}
                          type='text'
                          value={value}
                          onChange={onChange}
                          autoComplete='false'
                          placeholder='Enter Last name'
                          maxLength={25}
                          onKeyDown={(event) => {
                            const regex = new RegExp('^[a-zA-Z0-9\\s]+$')
                            if (
                              !regex.test(event.key) &&
                              event.key !== 'Backspace'
                            ) {
                              event.preventDefault()
                            }
                          }}
                        />
                      )}
                      defaultValue=''
                    />
                    <small className='error-input'>
                      {errors?.last_name?.message}
                    </small>{' '}
                  </div>
                </div>
                <div className='col-lg-6 col-12'>
                  <div className='form-wrap'>
                    <label className='col-form-label' />
                    Email
                    <Controller
                      name='email'
                      control={control}
                      render={({ field: { value, onChange } }) => (
                        <input
                          className={`form-control`}
                          type='text'
                          value={value}
                          onChange={onChange}
                          autoComplete='false'
                          placeholder='mamatha0935@gmail.com'
                          maxLength={25}
                          disabled
                        />
                      )}
                      defaultValue=''
                    />
                  </div>
                </div>
                <div className='col-lg-6 col-12'>
                  <div className='form-wrap'>
                    <label>Phone Number</label>
                    <Controller
                      name='phone_no'
                      control={control}
                      render={({ field: { value, onChange } }) => (
                        <input
                          className={`form-control  ${
                            errors?.phone_no ? 'error-input' : ''
                          }`}
                          type='text'
                          value={value || ''}
                          onChange={(e) => {
                            const inputValue = e.target.value
                            const sanitizedValue = inputValue.replace(
                              /[^+0-9]/g,
                              '',
                            )
                            onChange(sanitizedValue)
                          }}
                          autoComplete='false'
                          placeholder='Enter phone no'
                          maxLength={13}
                          pattern='[+0-9]*'
                        />
                      )}
                      defaultValue=''
                    />
                    <small className='error-input'>
                      {errors?.phone_no?.message}
                    </small>{' '}
                  </div>
                </div>
                <div className='col-lg-6 col-md-12'>
                  <div className='form-wrap'>
                    <label className='col-form-label'>New Password</label>
                    <div className='pass-group'>
                      <Controller
                        name='password'
                        control={control}
                        render={({ field: { value, onChange } }) => (
                          <input
                            value={value || ''}
                            onChange={onChange}
                            autoComplete='false'
                            type={passwordType}
                            className={`form-control pass-input ${
                              errors?.password ? 'border border-danger' : ''
                            }`}
                          />
                        )}
                      />
                      <span
                        onClick={() => {
                          passwordType === 'password'
                            ? setPasswordType('text')
                            : setPasswordType('password')
                        }}
                        className={`toggle-password fa-solid ${
                          passwordType === 'text' ? 'fa-eye' : 'fa-eye-slash'
                        }`}
                      ></span>
                    </div>
                    <small className='text-danger'>
                      {errors.password?.message}
                    </small>
                  </div>
                </div>
                <div className='col-lg-6 col-md-12'>
                  <div className='form-wrap'>
                    <label className='col-form-label'>
                      Confirm New Password
                    </label>
                    <div className='pass-group'>
                      <Controller
                        name='confirm_password'
                        control={control}
                        render={({ field: { value, onChange } }) => (
                          <input
                            value={value || ''}
                            onChange={onChange}
                            autoComplete='false'
                            type={confirmpasswordType}
                            className={`form-control pass-input ${
                              errors?.confirm_password
                                ? 'border border-danger'
                                : ''
                            }`}
                          />
                        )}
                      />
                      <span
                        onClick={() => {
                          confirmpasswordType === 'password'
                            ? setConfirmPasswordType('text')
                            : setConfirmPasswordType('password')
                        }}
                        className={`toggle-password fa-solid ${
                          confirmpasswordType === 'text'
                            ? 'fa-eye'
                            : 'fa-eye-slash'
                        }`}
                      ></span>
                    </div>
                    <small className='text-danger'>
                      {errors.confirm_password?.message}
                    </small>
                  </div>
                </div>
                <div className='col-lg-12'>
                  <div className='btn-access'>
                    {/* <Link to='#' className='btn btn-cancel'>
                    <i className='ti ti-arrow-narrow-left me-2' />
                    Previous
                  </Link> */}
                    <button
                      type='submit'
                      className='btn btn-primary'
                      // onClick={() => setShowModal(true)}
                    >
                      Submit
                      <i className='ti ti-arrow-narrow-right ms-2' />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
          {error && (
            <div className='loginboxs'>
              <div className='alert alert-danger' role='alert'>
                {errorText}
              </div>
            </div>
          )}
        </div>
      </div>
      <AccessSuccessModal
        setShowModal={setShowModal}
        onOk={onOk}
        showModal={showModal}
        disableCancel={true}
        modalMessage={modalMessage}
        content="Please wait for admin approval. We'll notify you soon."
        title='Thank you for submitting your information'
      />
    </>
  )
}

export default UserAccess
